export default __webpack_public_path__ + "static/media/carbon_user-file-upload.75c9bc18.svg";